
	import { Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Component from 'vue-class-component';

	@Observer
	@Component({
		components: {}
	})
	export default class PrescriptionSummaryItem extends Vue {
		@Prop({ required: true }) itemTitle!: string;
		@Prop({ required: true }) itemValue!: string | string[];
	}
